import type { JSX } from 'solid-js';
import { AdminGate } from '../components/AdminGate';
import { AdminUserPanel } from '../components/AdminUserPanel';
import { SESSION_TOKEN } from '../lib/session';

// One person's admin page (`/admin/users/:id`, #5727). TOP-LEVEL like the rest
// of the console: off `/org/…` `apiFetch` sends no `X-Dz-Account`, and the
// person's memberships span orgs. Thin: <AdminGate/> keeps the panel (and its
// audited read) behind the staff wall. `token` is injectable for tests; the
// router mounts with no props.

export function AdminUser(props: { token?: string | null } = {}): JSX.Element {
  const token = props.token === undefined ? SESSION_TOKEN : props.token;
  return (
    <AdminGate token={token}>
      <AdminUserPanel token={token} />
    </AdminGate>
  );
}
